import $ from "jquery";

jQuery(function($) {
    
    // Use event delegation to handle clicks on elements with the class 'open-popup'
    $(document).on("click", ".open-popup", function(e) {
        e.preventDefault();
        e.stopPropagation();

        $('.popup').removeClass('active');
        $('.site-overlay').removeClass('active');
        $('body, html').addClass('disable-scrolling'); // Disable scrolling
        
        // Get the popup identifier from the clicked element
        let popup = $(this).data('popup');
        let $popup = $('#' + popup);

     
        if ($popup.length > 0) {
            $popup.addClass('active');
            $('.site-overlay').addClass('active');

            // Handle popups with a gallery
            if ($popup.hasClass('popup-gallery')) {
                let $images = $popup.find('.slider-img');
                $images.each(function() {
                    let $image = $(this);
                    let src = $image.data('src');
                    $image.attr('src', src);
                    $image.attr('srcset', src);
                });
            }
        }
    });

    // Close popup when 'close-popup' element is clicked
    $(document).on('click', '.close-popup', function(e) {
        e.preventDefault();
        $('.popup').removeClass('active');
        $('.site-overlay').removeClass('active');
        $('body, html').removeClass('disable-scrolling'); // Disable scrolling
    });

    // Prevent click events inside the popup from closing it
    $(document).on('click', '.popup', function(e) {
        e.stopPropagation();
    });

    // Close the popup when clicking outside of it
    $(window).on('click', function(e) {
        $('.popup').removeClass('active');
        $('.site-overlay').removeClass('active');
        $('body, html').removeClass('disable-scrolling'); // Disable scrolling
    });


    $(document).on("click", "a", function(e) {
        let href = $(this).attr('href');

        if (href.includes('popup')){
            e.preventDefault();
            e.stopPropagation();
            let popup = href.split('-')[1];
            openPopup(popup);
        }
        
    });
});

// Function to programmatically open a popup by name
export function openPopup(name) {
    let $popup = $('#popup-' + name);

    if ($popup.length > 0) {
        $popup.addClass('active');
        $('.site-overlay').addClass('active');
    }
}
